module.exports = __webpack_public_path__ + "static/media/studiofoto-monti.ca499231.jpg";